// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 40px 20px 80px;
  min-height: 100vh;
  background: #0d0d0d;
  color: #f2f2f2;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  text-align: center;
  box-sizing: border-box;
}

.logo {
  width: 160px;
  height: auto;
  margin-bottom: 30px;
  object-fit: contain;
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.4));
  transition: transform 0.3s ease;
}

.home h2 {
  font-size: 2.5rem;
  margin-bottom: 20px;
  font-weight: 600;
  color: #ffffff;
}

.home p {
  font-size: 1.2rem;
  max-width: 700px;
  margin-bottom: 30px;
  line-height: 1.6;
  color: #cccccc;
}

.home-start-button {
  padding: 14px 30px;
  background-color: #f7931a;
  color: #000;
  border: none;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(247, 147, 26, 0.3);
  text-decoration: none;
}

.home-start-button:hover {
  background-color: #ffa733;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(247, 147, 26, 0.4);
}

/* Responsive Styles */
@media (max-width: 768px) {
  .home h2 {
    font-size: 2rem;
  }

  .home p {
    font-size: 1.05rem;
    padding: 0 10px;
  }

  .home-start-button {
    font-size: 0.95rem;
    padding: 12px 24px;
  }
}

@media (max-width: 480px) {

  .logo {
    width: 120px;
    margin-bottom: 20px;
  }

  .home h2 {
    font-size: 1.7rem;
  }

  .home p {
    font-size: 1rem;
  }

  .home-start-button {
    font-size: 0.9rem;
    padding: 10px 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/css/Home.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,4DAA4D;EAC5D,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iDAAiD;EACjD,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,8CAA8C;EAC9C,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA;;EAEE;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF","sourcesContent":[".home {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 40px 20px 80px;\n  min-height: 100vh;\n  background: #0d0d0d;\n  color: #f2f2f2;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  text-align: center;\n  box-sizing: border-box;\n}\n\n.logo {\n  width: 160px;\n  height: auto;\n  margin-bottom: 30px;\n  object-fit: contain;\n  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.4));\n  transition: transform 0.3s ease;\n}\n\n.home h2 {\n  font-size: 2.5rem;\n  margin-bottom: 20px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.home p {\n  font-size: 1.2rem;\n  max-width: 700px;\n  margin-bottom: 30px;\n  line-height: 1.6;\n  color: #cccccc;\n}\n\n.home-start-button {\n  padding: 14px 30px;\n  background-color: #f7931a;\n  color: #000;\n  border: none;\n  border-radius: 10px;\n  font-size: 1rem;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(247, 147, 26, 0.3);\n  text-decoration: none;\n}\n\n.home-start-button:hover {\n  background-color: #ffa733;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(247, 147, 26, 0.4);\n}\n\n/* Responsive Styles */\n@media (max-width: 768px) {\n  .home h2 {\n    font-size: 2rem;\n  }\n\n  .home p {\n    font-size: 1.05rem;\n    padding: 0 10px;\n  }\n\n  .home-start-button {\n    font-size: 0.95rem;\n    padding: 12px 24px;\n  }\n}\n\n@media (max-width: 480px) {\n\n  .logo {\n    width: 120px;\n    margin-bottom: 20px;\n  }\n\n  .home h2 {\n    font-size: 1.7rem;\n  }\n\n  .home p {\n    font-size: 1rem;\n  }\n\n  .home-start-button {\n    font-size: 0.9rem;\n    padding: 10px 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
